export default __webpack_public_path__ + "static/media/urlPortfolioThumbnail.3141616b.svg";